import formatDateWithCustomFormat from "../../../../../utils/formatDate";
import Grid from "../../../../../components/Grid";

const defaultProps = {
  foundOrders: [],
  page: 1,
  pages: 1,
  total: 1,
  onChangePage: () => {},
};

const columns = [
  {
    title: "# Orden",
    field: "num_order",
    searchable: true,
    render: (rowData) => <span>{rowData?.num_order || ""}</span>,
  },
  {
    title: "# Guía",
    field: "tracking_id",
    searchable: true,
    render: (rowData) => <span>{rowData?.tracking_id || ""}</span>,
  },
  {
    title: "ID externo",
    field: "external_id",
    searchable: true,
    render: (rowData) => <span>{rowData?.external_id || ""}</span>,
  },
  {
    title: "Operador",
    field: "operator",
    searchable: true,
    render: (rowData) => <span>{rowData?.operator || ""}</span>,
  },
  {
    title: "Fecha de Creación",
    field: "created_at",
    searchable: true,
    render: (rowData) => (
      <span>
        {formatDateWithCustomFormat(rowData?.created_at, {
          format: "DD-MM-YYYY HH:mm:ss",
        })}
      </span>
    ),
  },
  {
    title: "Estado",
    field: "current_status",
    searchable: true,
    render: (rowData) => <span>{rowData?.current_status || ""}</span>,
  },
];

export const TableReadMassiveOrders = (props) => {
  const { foundOrders, page, totalPages, total, onChangePage } = {
    ...defaultProps,
    ...props,
  };

  return (
    <div>
      <Grid
        cols={columns}
        data={foundOrders}
        page={page}
        pages={totalPages}
        total={total}
        offset={10}
        showFilters={false}
        showRange={false}
        onChangePage={onChangePage}
      />
    </div>
  );
};
